import { render, staticRenderFns } from "./newsForm.vue?vue&type=template&id=4288a7f9&scoped=true"
import script from "./newsForm.vue?vue&type=script&lang=js"
export * from "./newsForm.vue?vue&type=script&lang=js"
import style0 from "./newsForm.vue?vue&type=style&index=0&id=4288a7f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4288a7f9",
  null
  
)

export default component.exports